import { FacetType } from "shared-services";
import {
  FiltersFieldNames,
  IFilterFieldConfig,
  IFilterValues,
} from "../../types";

import { getCheckboxGroupFilterConfigWithFacets } from "../GenericFields/CheckboxTypeFilters/getCheckboxGroupFilterConfigWithFacets";

export const contractStatusFilter: IFilterFieldConfig<IFilterValues> = {
  name: FiltersFieldNames.ContractStatus,
  facetNames: [FacetType.ContractStatus],
  defaultValue: {},
  modifiers: { showFilterControl: true },
  getFilterFiledProps: getCheckboxGroupFilterConfigWithFacets,
};
